<template>
  <div id="app">
    <div  class="login-container"
      v-if='this.$route.name === "login"
          || this.$route.name === "reset-password"
          || this.$route.name === "change-password"'>
      <router-view/>
    </div>

    <div class="container-fluid main" v-else>
      <div class="row">
        <Sidebar v-if="$store.state.sidebar" @click.native="close"/>
        <div class="col-md-11 right-content main-content">
          <router-view/>
          <loader/>
          <vue-snotify/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Sidebar from '@/components/Sidebar';
  import Loader from "@/components/Loader";
  import bus from '@/plugins/bus';

  export default {
    components: {
      Sidebar,
      Loader
    },
    methods: {
      close() {
        bus.$emit('closeUserForm')
      }
    }
  };
</script>

<style lang="scss">
  @import '../node_modules/bootstrap/scss/bootstrap.scss';
  @import "./assets/scss/app.scss";
  @import "./assets/scss/additional.scss";
  @import "./assets/scss/progress_pie.scss";
  @import "./assets/scss/vue-timepicker.scss";
</style>
